<div class="card">
  <div class="card-header">
    <div class="flex-between">
      <div class="flex-start">
        <a class="p-1 btn btn-light flex-start d-inline-flex" routerLink="/dash/race-details" [queryParams]="{
          event_id: event_id,
          venue_id: venue_id,
          race_id: race_id
        }">
          <i class="fa fa-angle-left" aria-hidden="true"></i>
          <span>Back to Race Page</span>
        </a>
        <h5 class="mb-0 pb-0">Race Runner Map</h5>
      </div>
      <div class="d-flex align-items-center">
        <div class="me-3">
          <label for="throttleSlider" class="form-label mb-0 me-2">Update Interval: {{throttleInterval}}ms</label>
          <input type="range" class="form-range" id="throttleSlider" [min]="minThrottle" [max]="maxThrottle"
            [value]="throttleInterval" (input)="updateThrottleInterval($event)">
        </div>
        <button class="btn btn-primary-soft" (click)="recenterMap()">Recenter</button>
        <div class="layout-controls me-3">
          <button class="btn btn-primary-soft" [ngClass]="{'active': layoutMode === 'vertical'}"
                  (click)="setLayout('vertical')" title="Stack vertically">
            <i class="fa fa-arrows-v"></i>
          </button>
          <button class="btn btn-primary-soft" [ngClass]="{'active': layoutMode === 'horizontal'}"
                  (click)="setLayout('horizontal')" title="Place side by side">
            <i class="fa fa-arrows-h"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="card-body">
    <div class="flex-end">
      <div class="race-paginator flex-start" *ngIf="races.length > 0">
        <a class="race-navigator flex-start" [class.disabled]="selectedRaceNumber == 1" (click)="prev()">
          <i class="fa fa-angle-left"></i>
          Previous
        </a> <a class="race-navigator" *ngFor="let race of races"
          [routerLink]="['/dash/race-runner-map', venue_id, event_id, race.ExternalRaceId]"
          [class.active]="race.ExternalRaceId == race_id">
          <span class="race-text">{{ race.SquentialRaceOrderNumber }}</span>
          <div class="tooltip-container">
            <div class="tooltip-content">
              <div class="flex-start">
                <div class="fw-bold white-space-none">
                  #{{ race["SquentialRaceOrderNumber"] }}
                  {{ race.RaceName }} | {{ race.RaceTime }}
                </div>
                <span class="fw-bold me-2" *ngIf="race['RaceState'] == 'PLANNED' && race['RaceTimeMs'] > currentTimeMs">
                  Starts in {{ (race['RaceTimeMs'] - currentTimeMs) | date:'HH:mm:ss':'UTC' }}
                </span>
                <span class="status-text-container alert inline-flex-start" [ngClass]="{
                    'alert-success':
                      race.RaceState == 'FINISHED' ||
                      race.RaceState == 'QA PASSED' ||
                      race.RaceState == 'PUBLISHED',
                    'alert-dark':
                      race.RaceState == 'PLANNED' ||
                      race.RaceState == 'OFFICIAL',
                    'alert-danger':
                      race.RaceState == 'INCOMPLETED' ||
                      race.RaceState == 'QA FAILED' ||
                      race.RaceState == 'CANCELLED' ||
                      race.RaceState == 'DIDNOTTRACK' ||
                      race.RaceState == 'ABANDONED'
                  }">
                  <i class="fa fa-circle color-inherit" aria-hidden="true"></i>
                  <span class="color-inherit">{{
                    race["RaceState"] || "-"
                    }}</span>
                </span>
              </div>
            </div>
          </div>
        </a>
        <a class="race-navigator flex-start" [class.disabled]="selectedRaceNumber == races.length" (click)="next()">
          Next
          <i class="fa fa-angle-right"></i>
        </a>
      </div>
    </div>
    <div class="race-details mb-3">
      <div class="details-group">
        <h6>Race Information</h6>
        <div class="grid-3">
          <div class="detail-item" *ngIf="selectedRace">
            <span class="label">Venue:</span>
            <span class="value">{{ venueName }}</span>
          </div>
          <div class="detail-item">
            <span class="label">Race Number:</span>
            <span class="value">{{ selectedRaceNumber }}</span>
          </div>
          <div class="detail-item" *ngIf="selectedRace">
            <span class="label">Race Name:</span>
            <span class="value">{{ selectedRace.RaceName }}</span>
          </div>
          <div class="detail-item" *ngIf="selectedRace">
            <span class="label">Race Time:</span>
            <span class="value">{{ selectedRace.RaceTimeStr }}</span>
          </div>
          <div class="detail-item" *ngIf="selectedRace">
            <span class="label">Race Starts In:</span>
            <span class="value"
              *ngIf="selectedRace['RaceState'] == 'PLANNED' && selectedRace['RaceTimeMs'] > currentTimeMs">
              {{ (selectedRace['RaceTimeMs'] - currentTimeMs) | date:'HH:mm:ss':'UTC' }}
            </span>
            <span class="value"
              *ngIf="!(selectedRace['RaceState'] == 'PLANNED' && selectedRace['RaceTimeMs'] > currentTimeMs)">
              -
            </span>
          </div>
          <div class="detail-item" *ngIf="selectedRace">
            <span class="label">Race Status:</span>
            <span class="value">
              <span class="status-text-container alert inline-flex-start" [ngClass]="{
                    'alert-success':
                      selectedRace.RaceState == 'FINISHED' ||
                      selectedRace.RaceState == 'QA PASSED' ||
                      selectedRace.RaceState == 'PUBLISHED',
                    'alert-dark':
                      selectedRace.RaceState == 'PLANNED' ||
                      selectedRace.RaceState == 'OFFICIAL',
                    'alert-danger':
                      selectedRace.RaceState == 'INCOMPLETED' ||
                      selectedRace.RaceState == 'QA FAILED' ||
                      selectedRace.RaceState == 'CANCELLED' ||
                      selectedRace.RaceState == 'DIDNOTTRACK' ||
                      selectedRace.RaceState == 'ABANDONED'
                  }">
                <i class="fa fa-circle color-inherit" aria-hidden="true"></i>
                <span class="color-inherit">{{
                  selectedRace["RaceState"] || "-"
                  }}</span>
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="visualization-sections" [ngClass]="{'layout-horizontal': layoutMode === 'horizontal' ? true : false}">
      <div class="form-section map-section">
        <div id="map-container">
          <div id="map"></div>
        </div>
      </div>
      <div class="form-section entrants-section" *ngIf="selectedRace">
        <div class="entrants-list">
          <div class="list-group">
            <table class="table table-docs sticky-columns">
              <thead>
                <tr>
                  <th></th>
                  <th></th>
                  <th>Rank</th>
                  <th>SCN</th>
                  <th>Barrier/Box</th>
                  <th>Image</th>
                  <th>Animal Name</th>
                  <th>Distance to Finish</th>
                  <th>Distance Travelled</th>
                  <th *ngFor="let section of selectedRace['raceHeadersMain']">
                    <div class="center">
                      <div claas="mb-2">{{ section["sectionName"] }}</div>
                      <div>{{ section["intermediateTime"] }}</div>
                      <div>({{ section["sectionTime"] }})</div>
                    </div>
                  </th>
                  <th>Overall Time</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let entrant of (selectedRace.entrants | sortByRankDnsDnf)"
                  [class.dns]="runners[entrant.ExternalAnimalID]?.isDNS">
                  <td>
                    <input type="checkbox" [checked]="entrant.isSelected"
                      [disabled]="runners[entrant.ExternalAnimalID]?.isDNS" (change)="toggleEntrant(entrant)"
                      [id]="'entrant-' + entrant.ExternalAnimalID">
                  </td>
                  <td>
                    <div class="color-indicator me-2"
                      [style.background-color]="entrantColors[entrant.ExternalAnimalID]"></div>
                  </td>
                  <td>{{ entrant.Rank || "-" }}</td>
                  <td>{{ entrant.StartNumber }}</td>
                  <td>{{ entrant.BarrierNumber }}</td>
                  <td>
                    <img [src]="getSilkUrl(entrant)" alt="Image" style="height: 40px" />
                  </td>
                  <td>
                    {{ entrant.AnimalName }}
                  </td>
                  <td>
                    {{
                    entrant.RaceState.toUpperCase() != "DNS" && runners[entrant.ExternalAnimalID]?.distanceToGo &&
                    runners[entrant.ExternalAnimalID].distanceToGo !== '-'
                    ? runners[entrant.ExternalAnimalID].distanceToGo + 'm'
                    : "-"
                    }}
                  </td>
                  <td>
                    {{
                    entrant.RaceState.toUpperCase() != "DNS" && runners[entrant.ExternalAnimalID]?.distanceTraveled !=
                    null
                    ? runners[entrant.ExternalAnimalID].distanceTraveled + 'm'
                    : "-"
                    }} </td>
                  <ng-container *ngIf="entrant['sections']; else show_no_sections">
                    <td *ngFor="let section of entrant['sections']">
                      {{
                      entrant.RaceState.toUpperCase() != "DNS"
                      ? section["sectionTime"] || "-"
                      : "-"
                      }}
                    </td>
                  </ng-container>
                  <ng-template #show_no_sections>
                    <td *ngFor="let section_name of selectedRace['raceHeaders']">
                      -
                    </td>
                  </ng-template>
                  <td>
                    {{
                    entrant.RaceState.toUpperCase() != "DNS"
                    ? getOverallTime(selectedRace, entrant) || "-"
                    : "-"
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
